import { useMutation } from "react-query";
import { createInterventionHistory } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useCreateInterventionHistory = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    ({ clientId, payload }: { clientId: number; payload: Record<string, any> }) =>
      createInterventionHistory(clientId, payload),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Intervention record added successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error || "Failed to add intervention record";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    createInterventionHistoryMutation: mutate,
    isCreateInterventionHistoryLoading: isLoading,
    ...rest,
  };
};

export default useCreateInterventionHistory;
